import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["prefixCls", "className", "children"];
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var LayoutHeader = /*#__PURE__*/React.forwardRef((props, ref) => {
  var _ref = props || {},
    {
      prefixCls = 'w-layout-header',
      className,
      children
    } = _ref,
    other = _objectWithoutPropertiesLoose(_ref, _excluded);
  var cls = [prefixCls, className].filter(Boolean).join(' ').trim();
  return /*#__PURE__*/_jsx("header", _extends({
    ref: ref,
    className: cls
  }, other, {
    children: children
  }));
});